/**
 * 应用的全局状态管理
 */
import { atom } from 'jotai'
import type { ThemeType } from 'src/shared/common-types.js'

/** 颜色的默认值，就是先检查 localStorage，然后检查 prefers-color-scheme */
const defaultTheme =
  localStorage.theme === 'dark' ||
  (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)
    ? 'dark'
    : 'light'
const themeAtom = atom<ThemeType>(defaultTheme)

export { themeAtom }
